import { TInputParams } from 'entries/common/widgets/context';
import { getAreaState } from 'pages/common/helpers/get-area';
import { TInputParams as RoomsInputParams } from 'pages/common/types';
import { ParametersEnum } from '../types';

type TProps = {
  defaultInputParams: TInputParams;
  hasLengthWidth: boolean;
  isAreaEnabled: boolean;
  inputParameters: TInputParams;
  hasArea: boolean;
  hasNotWallArea: boolean;
};

export const getFilteredInputDefaultState = ({
  defaultInputParams,
  hasLengthWidth,
  isAreaEnabled,
  inputParameters,
  hasArea,
  hasNotWallArea,
}: TProps) =>
  getAreaState({
    inputParams: defaultInputParams as RoomsInputParams,
    isEnabled: hasLengthWidth
      ? hasArea && isAreaEnabled
      : inputParameters.includes(ParametersEnum.area) && !hasNotWallArea,
  });
